export type PortalVersion = 'classic' | 'v2';

const PORTAL_VERSION_STORAGE_KEY = 'devops.portal.version';

export const getPortalVersion = (): PortalVersion => {
  if (typeof window === 'undefined') {
    return 'classic';
  }

  return window.localStorage.getItem(PORTAL_VERSION_STORAGE_KEY) === 'v2' ? 'v2' : 'classic';
};

export const setPortalVersion = (version: PortalVersion) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(PORTAL_VERSION_STORAGE_KEY, version);
  }
};
